import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import ProjectSelect from './ProjectSelect'
import ScenarioSelect from './ScenarioSelect'
import SettingMenu from './SettingMenu'
import Logout from './../Logout'
import Logo from './Logo'
import NewProject from './NewProject'
import NewScenario from './NewScenario'
import Delete from './Delete'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'

const PREFIX = 'Header'
const classes = {
  main: `${PREFIX}`,
}

const Header = styled('div')({
  [`&.${classes.main} .MuiToolbar-root`]: {
    backgroundColor: '#333',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
  [`&.${classes.main} .MuiFormControl-root`]: {
    margin: '4px 16px;',
    marginRight: '8px;',
  },
  [`&.${classes.main} .MuiFormLabel-root`]: {
    color: 'rgba(255, 255, 255) !important;',
    fontSize: 15,
  },
  [`&.${classes.main} .MuiFilledInput-root`]: {
    width: 170,
    height: 45,
    position: 'relative',
    fontSize: 15,
    color: 'white',
  },
  [`&.${classes.main} .MuiFilledInput-underline:before`]: {
    borderBottom: '1px solid rgba(255, 255, 255) !important;',
  },
  [`&.${classes.main} .MuiFilledInput-underline:after`]: {
    borderBottom: '1px solid rgba(255, 255, 255) !important;',
  },
  [`&.${classes.main} .MuiSelect-icon`]: {
    color: 'rgba(255, 255, 255) !important;',
  },
  [`&.${classes.main} .MuiTypography-h6`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`&.${classes.main} .new-project-button`]: {
    marginLeft: '20px',
  },
  [`&.${classes.main} .new-scenario-button`]: {
    marginLeft: '20px',
    marginRight: '5px',
  },
  [`&.${classes.main} .MuiButton-root`]: {
    minWidth: 'auto',
  },
  [`&.${classes.main} .Logout-container`]: {
    marginLeft: '10px',
  },
})

const Lhs = styled('div')({
  display: 'inline-flex;',
  flex: '1;',
})

export default function DenseAppBar() {
  const { selectedProjectId } = useSelector(state => state)

  return (
    <Header className={classes.main}>
      <AppBar position="fixed">
        <Toolbar variant="dense">
          <Lhs>
            <Logo />
            <Typography variant="h6" color="inherit">
              VDA
            </Typography>
            <ProjectSelect />
            {selectedProjectId !== null ? <ScenarioSelect /> : <div />}
          </Lhs>
          <NewProject />
          {selectedProjectId !== null ? <NewScenario /> : <div />}
          {selectedProjectId !== null ? <Delete /> : <div />}
          <SettingMenu />
          <Logout />
        </Toolbar>
      </AppBar>
    </Header>
  )
}
